export default "__VITE_ASSET__CuJ3XoUo__"